<template>
  <b-container>
    <h1 v-translate>Bulk Outsourcing Quotes</h1>
    <bulk-quote-3p-list />
  </b-container>
</template>
<script>
import BulkQuote3pList from '@/components/BulkQuote3PList'

export default {
  name: 'BulkQuote3pListPage',
  components: {
    BulkQuote3pList
  }
}
</script>
